import { Component, Input, OnInit, inject, output } from '@angular/core';

import { AnchorDirective, NavigationService } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { UrlConstants } from '../../../config/urlConstants';
import { MessageType } from '../../../model/message.model';
import { DataService } from '../../../service/data.service';
import { GtmService } from '../../../service/gtm.service';
import { QdApiService } from '../../../service/qd.service';
import { UserDataService } from '../../../service/userDataService';
import { MessageComponent } from '../../../shared/components/messages/message-component';
import { ADAMessageComponent } from './ada-message/ada-message.component';
import { ARCMessageComponent } from './arc-message/arc-message.component';
import { PLVerificationMessageComponent } from './pl-verification-message/pl-verification-message.component';
import { PlayBreakMessageComponent } from './play-break-message/play-break-message.component';
import { ReversalNotificationComponent } from './reversal-notification/reversal-notification.component';
import { SessionLimitsComponent } from './session-limits/session-limits.component';

@Component({
    selector: 'app-additional-messages',
    templateUrl: 'additional-messages.component.html',
    imports: [
        ADAMessageComponent,
        PlayBreakMessageComponent,
        ARCMessageComponent,
        PLVerificationMessageComponent,
        ReversalNotificationComponent,
        SessionLimitsComponent,
        MessageComponent,
        TranslateModule,
        AnchorDirective,
    ],
})
export class AdditionalMessagesComponent implements OnInit {
    type: MessageType;
    private navigationService = inject(NavigationService);
    activeDepositCurfewInfo = output<boolean>();
    isEsRiskPlayer: boolean;
    @Input() selectedOption: { paymentAccountInfo: { isESRiskPlayer: string } };
    liveChatRiskPlayerUrl: string;
    activeDepositCurfew: boolean;
    depositCurfewRedirectUrl: string;
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    constructor(
        private gtmService: GtmService,
        private userDataService: UserDataService,
        private dataService: DataService,
        private apiService: QdApiService,
    ) {}
    ngOnInit() {
        const lang = this.dataService?.sessionInfo?.langId ?? 'en';
        this.liveChatRiskPlayerUrl = `${this.userDataService?.userData?.configParams?.merchant_hostname}/${lang}${UrlConstants.LIVE_CHAT_ES_LINK}`;

        this.isEsRiskPlayer = this.selectedOption?.paymentAccountInfo?.isESRiskPlayer == 'Y';
        if (this.isEsRiskPlayer) {
            this.gtmService.riskyPlayerAccountTempBlock();
        }
        this.getDepositCurfewDetails();
    }
    liveChatUrlRisky() {
        this.gtmService.riskyPlayerClickOnLiveChat('account restricted message', this.liveChatRiskPlayerUrl);
        this.navigationService.goTo(this.liveChatRiskPlayerUrl, { forceReloadTarget: 'top' });
    }
    getDepositCurfewDetails() {
        this.apiService.get(UrlConstants.DEPOSIT_CURFEW_DETAILS_URI).subscribe((response) => {
            if (response && response?.inDepositCurfew) {
                this.activeDepositCurfew = response?.inDepositCurfew;
                this.activeDepositCurfewInfo.emit(!!this.activeDepositCurfew);
                this.depositCurfewRedirectUrl = response?.depositCurfewUrl?.url;
            }
        });
    }
}
